import { makeStyles } from '@material-ui/styles'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import ProgressGraph from 'core/components/graphs/ProgressGraph'
import Card from 'core/elements/card'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'

export interface QuotaItem {
  label: string
  usage: number
  capacity: number
  unit?: string
}

interface QuotaCardProps {
  title: string
  icon: string
  quotas: QuotaItem[]
}

const QuotaCard = ({ title, icon, quotas }: QuotaCardProps) => {
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <div className={classes.cardBody}>
        <div className={classes.cardHeader}>
          <div className={classes.iconContainer}>
            <FontAwesomeIcon className={classes.icon} solid>
              {icon}
            </FontAwesomeIcon>
          </div>
          <Text variant="subtitle2">{title}</Text>
        </div>
        {quotas.map((quota) => (
          <ProgressGraph
            key={quota.label}
            label={quota.label}
            usage={quota.usage}
            capacity={quota.capacity}
            unit={quota.unit}
          />
        ))}
      </div>
    </Card>
  )
}

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  card: {
    width: '100%',
    flexGrow: 1,
  },
  cardBody: {
    display: 'grid',
    gap: 12,
  },
  cardHeader: {
    display: 'grid',
    alignItems: 'center',
    justifyContent: 'center',
    gridTemplateColumns: 'auto auto',
    gap: 8,
    marginBottom: 8,
  },
  iconContainer: {
    background: theme.palette.grey[100],
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 32,
    width: 32,
  },
  icon: {
    fontSize: '18px',
    color: theme.palette.grey[500],
  },
}))

export default QuotaCard
